<script>
    export let context;
    context;
    import Twitter from "../components/TwitterEmbed.svelte";
    import Image from "../components/Image.svelte";
</script>

<section class="hero is-info">
    <div class="hero-body">
        <div class="container">
            <h1 class="title">The Skill Tree Company</h1>
            <h2 class="subtitle">Latest news and activities</h2>
        </div>
    </div>
</section>
<div class="tile is-ancestor">
    <div class="tile is-vertical is-10">
        <div class="tile is-parent">
            <article class="tile is-child box">
                <p class="title">Current Activities</p>
                
                    <Image src="/images/calmtree.jpg" alt=""/>
                    
                

                <p class="subtitle">
                    Enjoy this months calming image while our next initiatives are
                    under development
                </p>
            </article>
        </div>
        <div class="tile is-parent">
            <article class="tile is-child box">
                <p class="title">Quote of the Month</p>
                <p class="subtitle">
                    “Today, give yourself permission to be outrageously kind,
                    irrationally warm, improbably generous. I promise it will be
                    a blast.” – Sasha Dicter
                </p>
            </article>
        </div>
        <div class="tile is-parent">
            <article class="tile is-child box">
                <p class="title">Worth a look</p>
                <p class="subtitle">
                    Look at our Resources Page for good books and short film
                    clips!
                </p>
            </article>
        </div>
    </div>
    <div class="tile is-parent">
        <div class="tile is-child">
            <Twitter name="TheSkillTreeCo" height="1200" />
        </div>
    </div>
</div>
